<template>
  <div>

    <v-text-field label=" انتخاب کاربر" :value="name" dense
                  outlined readonly append-icon="mdi-crosshairs" class="cursor-pointer" @click="dialog = true"
                  :disabled="disabled"
                  ref="input" :error-messages="errors"/>

    <v-dialog v-model="dialog" scrollable max-width="800px">
      <v-card elevation="2" outlined :loading="loading">
        <v-card-title>
          انتخاب کاربر
          <v-spacer></v-spacer>
          <v-btn small icon rounded @click="dialog = false, $emit('changeUserId', value = null)" class="ml-1 text-danger">
            <v-icon  >mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-actions>
          <v-text-field label="جستجو" append-icon="mdi-magnify"
                        v-model="search"
                        hide-details class="my-3"/>
        </v-card-actions>

        <v-list style="background: white; z-index: 999" >
          <v-list-item @click="pick(x)" v-for="(x,i) in manufacturers.data" :key="i">

            <v-list-item-content>
              <v-list-item-title v-text="x.name"/>
              <v-list-item-subtitle v-text="x.username">
              </v-list-item-subtitle>
            </v-list-item-content>


            <v-list-item-action v-if="x.id === value">
              <v-icon>mdi-check</v-icon><!--        <v-divider></v-divider>-->

            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-card-actions class="justify-end" style="background: white; z-index: 999">
          <hr>
          <v-spacer></v-spacer>

<!--          <pagination :data="manufacturers.data" :visible="2" v-on:page="fetch(url, tableProps)"/>-->
          <Paginate :total="manufacturers.last_page" :links="manufacturers.links" :tableProps="tableProps" @changePage="fetch(url, tableProps)"></Paginate>



          <v-btn  outlined class="mr-auto btn-cancel" text @click="dialog = false, $emit('changeUserId', value = null)">
            <v-icon>mdi-close-circle</v-icon>
            <b>بستن</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Paginate from "@/view/pages/admin/Messages/Paginate";
import {qrAxios} from "@/main";

export default {
  components: {Paginate},
  name: "UsersComponent",

  props: ['value', 'errors', 'disabled'],

  model: {
    prop: 'value',
    event: 'manufacturersPicker'
  },

  computed: {
    manufacturer_name: function () {
      if (this.model === null) return "";
      return this.model.name;
    },
  },

  data () {
    return {
      dialog: false,
      loading: false,
      search: null,
      manufacturers: [],
      data:{},
      name:null,
      model: [],
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
      url: 'admin/users'
    }
  },

  watch: {
    model(val) {
      this.name = val.name
    },
    value(val) {
      if (val === null)
        return this.name = null
      return this.name = this.model.name
      // this.findModel();
    },
    search(val) {
      if (val.length >=3){
        this.tableProps.search = val
        this.fetch(this.url, this.tableProps)
      }
    }
  },

  created() {
    this.fetch(this.url);
    this.manufacturers.find(x => {

      if (x.id === this.value) {
        this.manufacturer_name = x.name;
      }
    });
  },

  methods: {
    fetch(url=this.url, props=this.tableProps) {
      this.requestApiGet(url, props )
          .then(({data}) => {
            this.data=data
            this.manufacturers = data
          })
          .catch(({response}) => this.$root.$emit('errorToast', response.data.message))
          .finally(() => this.loading = false);


    },
    findModel() {
      if (this.value == null) return;

      this.loading = true;

      qrAxios.get(`manufacturers/${this.value}`)
          .then(({data}) => this.model = data)
          .catch(({response}) => this.$root.$emit('errorToast', response.data.message))
          .finally(() => this.loading = false);
    },
    pick(x) {
      this.$emit('manufacturersPicker', x.id);
      this.model = x;
      this.dialog = false;
    }
  }
}
</script>

<style scoped>

</style>
